import { render } from "./MfaDialog.vue?vue&type=template&id=530132f0"
import script from "./MfaDialog.vue?vue&type=script&lang=js"
export * from "./MfaDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__